module.exports = __webpack_public_path__ + "img/base_restauration_etoile.9ef776f5.svg";